import React from 'react';
import { EntityDescription } from '../../Api/interfaces';
import PickupRow from './PickupRow';
import './styles.css';

interface Props {
  entity: EntityDescription;
}

export default class PickupsTable extends React.Component<Props> {
  render(): JSX.Element {
    const { entity } = this.props;
    return (
      <tr>
        <td valign="top">
          <div id="Pickup" className="propertyName">
            Pickup Items
          </div>
        </td>
        <td>
          <table className="fieldsTable">
            <tbody>
              <tr className="fieldsHeader">
                <th className="fieldsHeader"></th>
                <th className="fieldsHeader">Display Value</th>
                <th className="fieldsHeader">Value</th>
                <th className="fieldsHeader">Color</th>
                <th className="fieldsHeader">Description</th>
              </tr>
              {entity.pickups.map((f) => (
                <PickupRow pickUp={f} key={f.value} />
              ))}
            </tbody>
          </table>
        </td>
      </tr>
    );
  }
}
